import { useEffect, useState, useCallback } from 'react';
import { TOAST } from './utils';
import type { TToast } from './toast.types';

type TUseToastItemConfig = {
	toast: TToast;
	onRemove: (id: string) => void;
};

type TUseToastItemReturn = {
	isExiting: boolean;
	handleClose: () => void;
};

const useToastItem = ({ toast, onRemove }: TUseToastItemConfig): TUseToastItemReturn => {
	const [isExiting, setIsExiting] = useState(false);

	useEffect(() => {
		const duration = toast.duration ?? TOAST.DEFAULT_DURATION_MS;
		const exitTimer = setTimeout(() => setIsExiting(true), duration - TOAST.EXIT_TRIGGER_OFFSET_MS);
		const removeTimer = setTimeout(() => onRemove(toast.id), duration);

		return () => {
			clearTimeout(exitTimer);
			clearTimeout(removeTimer);
		};
	}, [toast.id, toast.duration, onRemove]);

	const handleClose = useCallback(() => {
		setIsExiting(true);
		setTimeout(() => onRemove(toast.id), TOAST.EXIT_ANIMATION_MS);
	}, [toast.id, onRemove]);

	return { isExiting, handleClose };
};

export { useToastItem };
